import { render, staticRenderFns } from "./productTable.vue?vue&type=template&id=2f75a9fe&scoped=true"
import script from "./productTable.vue?vue&type=script&lang=js"
export * from "./productTable.vue?vue&type=script&lang=js"
import style0 from "./productTable.vue?vue&type=style&index=0&id=2f75a9fe&prod&lang=css"
import style1 from "./productTable.vue?vue&type=style&index=1&id=2f75a9fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f75a9fe",
  null
  
)

export default component.exports